/**
 * Fresh nonces for the AJAX endpoints (upload, add-to-cart).
 *
 * The nonces localized into the product page go stale in 12-24 hours, but the
 * page itself is served from LiteSpeed's full-page cache for far longer. Rather
 * than making the page uncacheable, we fetch a live nonce from admin-ajax.php
 * (never page-cached) the first time the customer does something that needs one.
 *
 * The request is made once per page and shared by both callers; a forced
 * refresh is available so a rejected request can retry with a new nonce.
 */

/** In-flight or settled request, so N callers cause exactly one round trip. */
let inFlight = null;

/** The ajaxUrl comes from whichever endpoint config the page localized. */
function ajaxUrl() {
  const upload = window.SnapmagnetiqueUpload;
  const cart = window.SnapmagnetiqueCart;
  return (upload && upload.ajaxUrl) || (cart && cart.ajaxUrl) || '';
}

/** Write the returned nonces back onto the live config objects. */
function apply(data) {
  if (!data) {
    return;
  }
  if (window.SnapmagnetiqueUpload && data.upload) {
    window.SnapmagnetiqueUpload.nonce = data.upload;
  }
  if (window.SnapmagnetiqueCart && data.cart) {
    window.SnapmagnetiqueCart.nonce = data.cart;
  }
}

/**
 * Resolve once the configs hold a server-issued nonce. Network failures resolve
 * too: the localized nonce is still worth a try, and the caller reports the
 * real error if it is rejected.
 */
export function ensureNonces() {
  if (inFlight) {
    return inFlight;
  }

  const url = ajaxUrl();
  if (!url) {
    inFlight = Promise.resolve();
    return inFlight;
  }

  inFlight = fetch(`${url}?action=snapmagnetique_nonces`, {
    method: 'GET',
    credentials: 'same-origin',
    cache: 'no-store',
  })
    .then((r) => r.json())
    .then((res) => {
      if (res && res.success) {
        apply(res.data);
      }
    })
    .catch(() => {});

  return inFlight;
}

/** Discard the cached result and fetch again (used to retry a rejected nonce). */
export function refreshNonces() {
  inFlight = null;
  return ensureNonces();
}
